var save_id = 0;
var cpt_save = 0;
var from_range = false;  //for wishlist

function addEvent(elem,event,name_function) {

    if (document.all) elem.attachEvent("on"+event,name_function);
    else elem.addEventListener(event,name_function,false);

}

function delEvent(elem,event,name_function) {

    if (document.all) elem.detachEvent("on"+event,name_function);
    else elem.removeEventListener(event,name_function,false);

}

// empeche les evenements de remonter dans l'arbre

function doNothing(e) {

if (document.all) {
  if (!e) var e = window.event;
  e.cancelBubble = true;
 }
 else {
    e.stopPropagation();
 }
 return false;
}
// popup guide des tailles
function showsizeguide() {
    var elname = 'sizeguidebox';

    var actualposition = document.documentElement.scrollTop;
    var modbox = document.getElementById(elname);
    var shade = document.getElementById('shade');

    modbox.style.position = "absolute";
    shade.style.display="block";

    addEvent(shade,'click',closesizeguide);

    addEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);

    modbox.style.display="block";

    window.scrollTo(0,actualposition);
}

function closesizeguide() {
    var elname = 'sizeguidebox';
    var shade = document.getElementById('shade');
    var modbox = document.getElementById(elname);
    modbox.style.display="";

    delEvent(shade,'click',closesizeguide);
    delEvent(modbox,'click',closesizeguide);
    delEvent(document.getElementById('menu_sizeguide'), 'click', doNothing);
    closemodal();
}

var addToCartTmpl;

function buildItemAddedModbox(id_produit, is_not_produit) {

    var form = document.getElementById('prod_info_' + id_produit);
    var closing_method = (is_not_produit == 'true') ? 'window.location.reload()' : 'closeMultiShad(\'modbox\')';

    if (document.getElementById('nbr_visu_0')) {

        var itm_vis = $('#img_large').attr('src').replace('/mini/', '/large/');
    }

    var itm_name = $('#itm_name').get(0).textContent.trim();

    if ($('#itm_feat', form).length > 0) {

        var itm_feat = $('#itm_feat', form).get(0).textContent.trim();
    }

    var itm_price = $(".item_price .pricetag").html();

    if ($(".pricetag:first + .pricetag", form).length) {

        var itm_fullprice = $(".pricetag:first + .pricetag", form).html();
    }

    if (form) {

        var itm_length = parseFloat(form.elements.namedItem('qteProd').value);
        var itm_color = form.elements.namedItem('couleurProd').value;
        var itm_size = form.elements.namedItem('tailleProd').value;

        if (itm_length > 1) {
            itm_length += ' ' + translate('items');
        } else {
            itm_length += ' ' + translate('item');
        }

        if (itm_length == 1) {
            itm_length += ' ' + translate('added_to_cart_sn');
        }
        if ($("input[name=itm_color]", form).length) {
            itm_color = $("input[name=itm_color]", form).filter("[value=" + itm_color + "]").next("label").attr("title").trim();
        }
        itm_size = $("input[name=taille]:checked").next("label").html();
    }

    $('#shade').after($('#modbox'));

    document.getElementById('modbox').innerHTML = Mustache.render(addToCartTmpl, {
        closing_method: closing_method,
        itm_vis: itm_vis,
        itm_name: itm_name,
        itm_feat: itm_feat,
        itm_price: itm_price,
        itm_fullprice: itm_fullprice,
        itm_length: itm_length,
        itm_color: itm_color,
        itm_size: itm_size
    });
}

function buildLookAddedModbox(is_not_produit) {

    var form = document.getElementById('slide_look_detail');
    var closing_method = (is_not_produit == 'true') ? 'window.location.reload()' : 'close_lightbox(\'modbox\')';
    var look_total = formatPrice(parseFloat(document.getElementById('look_total').value));
    var look_items = [];

    $('fieldset', form).each(function () {

        var itm_quantity = parseFloat($('.qte_select_wrapper select', this).get(0).value);

        if (itm_quantity > 0) {

            var new_look_itm = {};

            new_look_itm.itm_visu = $('.visu_look', this).attr('src').replace('/medium/', '/mini/');
            new_look_itm.itm_name = this.getValue('itm_name');
            new_look_itm.itm_quantity = itm_quantity;
            new_look_itm.itm_total = formatPrice(this.getValue('itm_price', parseFloat) * itm_quantity);

            look_items.push(new_look_itm);
        }
    });

    $('#shade').after($('#modbox'));

    document.getElementById('modbox').innerHTML = Mustache.render(addToCartTmpl, {
        closing_method : closing_method,
        look_total : look_total,
        look_items : look_items
    });
}

function newshowmodal(id_produit, is_not_produit) {

    if (!addToCartTmpl) {
        addToCartTmpl = document.getElementById('modbox').innerHTML.trim();
        Mustache.parse(addToCartTmpl);
    }
    if (type != 'err') {
        buildItemAddedModbox(id_produit, is_not_produit);
        openMultiShad('modbox');
    }
}

$(document).on('click', '#content_sendfriendbox #sendfriend_alert_mail + .w-form-line.w-submit .w-btn-wrapper', function () {
    closesendfriendmodal();
});

function closesendfriendmodal() {
    var modbox = document.getElementById('sendfriendbox');
    var shade = document.getElementById('shade');

    $('#sendfriendbox').slideUp("slow").queue(function () {
        $('#shade').fadeTo("slow", 0);
        $(this).dequeue();
        shade.style.display = 'none';
        modbox.style.display = 'none';
    });

    var sendfriendElements = {
        sendfriend_alert_mail: "none",
        sendfriend_prodinfos: "flex",
        sendfriend_form_to: "block",
        sendfriend_form_froms: "block",
        sendfriend_form_buttons: "block",
        sendfriend_form_needed: "block"
    };

    Object.entries(sendfriendElements).forEach(function ([id, display]) {
        var element = document.getElementById(id);
        if (element) element.style.display = display;
    });

    document.body.style.overflow='';
    document.getElementsByTagName("html")[0].style.overflow = "";

    delEvent(shade,'click',closesendfriendmodal);

    if ( navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1 ) {

        var svn=document.getElementsByTagName("SELECT");
        for (a=0;a<svn.length;a++) {
            svn[a].style.visibility="visible";
        }

    }
}

function closesendfriendmodalfromconfirm() {
    var modbox = document.getElementById('sendfriendbox');
    var shade = document.getElementById('shade');
    modbox.style.marginLeft='';
    shade.style.display="none";
    modbox.style.display="none";
    document.body.style.overflow='';
    document.getElementsByTagName("html")[0].style.overflow = "";

    var sendfriendElements = {
        sendfriend_prodinfos: "flex",
        sendfriend_form_to: "block",
        sendfriend_form_froms: "block",
        sendfriend_form_buttons: "block",
        sendfriend_form_needed: "block",
        sendfriend_alert_mail: "none"
    };

    Object.entries(sendfriendElements).forEach(function ([id, display]) {
        var element = document.getElementById(id);
        if (element) {
            element.style.display = display;
            if (id === "sendfriend_alert_mail") element.innerHTML = "";
        }
    });

    delEvent(shade,'click',closesendfriendmodal);

    if ( navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1 ) {

        var svn=document.getElementsByTagName("SELECT");
        for (a=0;a<svn.length;a++) {
            svn[a].style.visibility="visible";
        }

    }

}

function closemodal() {

    var modbox = document.getElementById('modbox');
    var cgvbox = document.getElementById('article_fourth_box_cgv');
    var errbox = document.getElementById('errbox');
    var cmodbox = document.getElementById('cmodbox');
    var shade = document.getElementById('shade');

    if (cmodbox) {

        cmodbox.innerHTML = '';
    }

    if (modbox) {

        modbox.style.marginLeft = '';
        modbox.style.display = 'none';
    }

    if (cgvbox) {
        cgvbox.style.display = 'none';
    }

    if (shade) {

        shade.style.display = 'none';
    }

    if (errbox) {

        errbox.style.display = 'none';
    }

    document.body.style.overflow = '';
    document.getElementsByTagName("html")[0].style.overflow = '';

    if ( navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1 ) {

        var svn=document.getElementsByTagName("SELECT");
        for (a=0;a<svn.length;a++) {
            svn[a].style.visibility="visible";
        }

    }
}

function addToBasketClick(btn)
{
    try {
        var options = JSON.parse(btn.attr('data-options'));
    } catch (e) {
        return false;
    }
    var from = '';
    var loader;
    addToBasket(options.product_id, options.suff, options.basket_id, options.prod_title_object, options.idTaille, options.lastTaille, options.idCouleur, options.lastCouleur, options.toEval, options.page_name, options.path_web, options.enable_omniture, options.is_not_produit, from, loader, options.configurator_product, options.configurator_option, options.is_reservation);
}


function waitingAddToBasket(evt, form_elm, from) {

    var id = '';
    var produit_id = form_elm.getValue('produit_id');
    var suff = form_elm.getValue('suff');
    var panier_id = form_elm.getValue('panier_id');
    var titreObjet = form_elm.getValue('titreObjet');
    var idTaille = form_elm.getValue('tailleProd');
    var lastTaille = form_elm.getValue('lastTaille');
    var idCouleur = form_elm.getValue('couleurProd');
    var lastCouleur = form_elm.getValue('lastCouleur');
    var toEval = form_elm.getValue('toEval');
    var page_name = form_elm.getValue('page_name');
    var path_web = form_elm.getValue('path_web');
    var enable_omniture = form_elm.getValue('enable_omniture');
    var is_not_produit = form_elm.getValue('is_not_produit');
    var is_lightbox_specifique = form_elm.getValue('is_lightbox_specifique');
    var loader;

    evt.preventDefault();

    if (from === undefined) {
        from = '';
    }

    if (is_not_produit == true) {
        id += '_' + produit_id;
    }

    if (this.nextElementSibling && this.nextElementSibling.classList.contains('loader')) {
        loader = $(this.nextElementSibling);

        loader.parent().addClass('loading');
    }

    window.setTimeout( function() {
        addToBasket(produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, false, false);
    }, 1000);

}

function addToBasket(produit_id, suff, panier_id, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, toEval, page_name, path_web, enable_omniture, is_not_produit, from, loader, configurator_product, configurator_option, is_reservation) {

    var id = '';

    prix_id = 'prixU';

    if (from == 'basket' || is_not_produit == true) {
        id += '_' + produit_id;
        prix_id = 'prixU' + id;

        if (is_not_produit == true) {

            var code_color = $('#couleurUnique' + id).text();
            var nom_color = $('#couleurUnique' + id).text();
        }
    }

    var array_panier = newUpdatePanier(produit_id, suff, panier_id, document.getElementById(prix_id).value, path_web, titreObjet, idTaille, lastTaille, idCouleur, lastCouleur, configurator_product, configurator_option, is_reservation);

    if (configurator_option === true) {
        return true;
    }


    if (array_panier != false && is_reservation !== true) {
        if (from == 'basket') {
            location.reload();
            return false;
        }

        var type = '';

        if (array_panier[1] == 'false' || array_panier.length == 0) {
            type = 'err';
        }

        omnitureEvent = '';

        if (array_panier[1] == 1) {
            omnitureEvent = 'scOpen,scAdd'; // le premier produit ajouté au panier
        } else {
            omnitureEvent = 'scAdd'; // il y a déjà un produit au panier
        }

        if (loader) {
            loader.parent().removeClass('loading');
        } else {
            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }

        if (array_panier[1] > 0 && enable_omniture == true) {
            void(s.t());
            s.pageName  = "'" + page_name + "'";
            s.products  = ";" + produit_id;
            s.events    = omnitureEvent;
            void(s.t());
        }

        // Mise à jour du panier top
        var response_basket = ajax_file(path_web + 'ajax_show_basket.php');
        $("#cart_top").html(response_basket);

        $("#shad").hide();
        $("#lightbox_achat_express").removeClass('opened');

        newshowmodal(produit_id, is_not_produit);
    } else {
        if (loader) {
            loader.parent().removeClass('loading');
        } else {
            $("#bloc_btn_active" + id).attr('class', '');
            $("#bloc_btn_loader" + id).attr('class', 'f_right cache');
        }

        var response_basket = ajax_file(path_web + 'ajax_show_basket.php');
        $("#cart_top").html(response_basket);

        return true;
    }

    eval(toEval);

    if (array_panier != false) {

        if (navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1) {

            var svn = document.getElementsByTagName("SELECT");

            for (a = 0; a < svn.length; a++) {

                svn[a].style.visibility = "hidden";
            }
        }
    }

    return false;
}

function updateZoomedImg(src) {

    $('.main_vis img', this).attr('src', src);
}

function zoomImg() {

    var container = $(this).closest('.itm_views');
    var thumbnail = $('.content_img_visu', container).clone();
    var main_visu = $(this).clone().removeAttr('id');
    var zoom_wrap = $('#zoom_box_wrapper');
    var shade = document.getElementById('shade');

    thumbnail.each(function () {

        var src = $('img', this).attr('src').replace('/medium/', '/large/');
        src = $('img', this).attr('src').replace('/mini/', '/large/');

        $(this).removeAttr('id');
        $('img', this).removeAttr('onclick');

        this.addEventListener('click', updateZoomedImg.bind(zoom_wrap, src));
    });

    $('.main_vis', zoom_wrap).html(main_visu);
    $('.more_vis', zoom_wrap).html(thumbnail);

    $('#shade').after($('#zoomBox')).add($('#zoomBox')).show();

    addEvent(shade,'click',closeZoom);
}

function closeZoom() {

    var elname = 'zoomBox';
    var modbox = document.getElementById(elname);
    var shade = document.getElementById('shade');
    var shade_zoom = document.getElementById('shade');
    modbox.style.display="none";
    shade_zoom.style.display="";

    delEvent(shade,'click',closeZoom);
    delEvent(shade_zoom,'click',closeZoom);
    delEvent(modbox,'click',closeZoom);

    closemodal();

}

function updateSrc(path_web,dest) {
    var tmp_string_large = document.getElementById('img_large').src;
    tmp_string = tmp_string_large.replace(/medium/,"large");

    document.getElementById('img_large').setAttribute('onclick','zoomImg(\''+tmp_string+'\',\''+path_web+'\')');
    document.getElementById('loupe').href = 'javascript:zoomImg(\''+tmp_string+'\',\''+path_web+'\');';
    $(".zoomLens").css({backgroundImage : 'url("'+tmp_string_large+'")' });

    if (dest=='vue') {

        var i = 0;
        var trouve = false;
        while (i<tab_js.length && !trouve) {

            trouve = (tab_js[i][0].substring(tab_js[i][0].lastIndexOf('/')+1)==tmp_string.substring(tmp_string.lastIndexOf('/')+1));
            i++;

        }

        cpt_img = (i-1);

    }

}

function productSendFriendForm(path_web, request_uri) {

    document.getElementById("product_sendfriend_ok").style.display = 'block';
    document.getElementById("product_sendfriend_nok").style.display = 'block';

    if ( document.getElementById('sendFriendToMails') && document.getElementById('sendFriendToMessage') && document.getElementById('sendFriendYourName') && document.getElementById('sendFriendYourMail') && document.getElementById('sendFriendCopy') ) {
        document.getElementById('sendFriendToMails').style.border="";
        document.getElementById('sendFriendToMessage').style.border="";
        document.getElementById('sendFriendYourName').style.border="";
        document.getElementById('sendFriendYourMail').style.border="";

        var token = document.getElementById('token_security_sendfriend').value;
        var captcha = document.getElementById('g-recaptcha-response').value;

        $.ajax({
            url: path_web + 'ajax_send_friend_form.php',
            type: 'POST',
            data: 'g-recaptcha-response=' + captcha + '&token_security=' + token + '&url=' + request_uri + '&to_mails=' + document.getElementById('sendFriendToMails').value + '&to_message=' + document.getElementById('sendFriendToMessage').value.replace(/\n/g,'<br>') + '&your_name=' + document.getElementById('sendFriendYourName').value + '&your_mail=' + document.getElementById('sendFriendYourMail').value + '&copy=' + document.getElementById('sendFriendCopy').checked
        }).done(function(response) {

            var content_id = 'product_sendfriend_nok',
                content = '';

            if (response.split(',')[0] == 'ok') {

                var s_adresse = response.substr(3);
                var sing = (response.split(',').length > 2) ? 'sendfriend_ok_plur' : 'sendfriend_ok_sing';

                content = '<div style="font-size:14px;font-weight:bold;font-family:Arial; color:#222;text-align:center;margin-bottom:10px;margin-top:15px;font-family: arial;">'+ajax_file(path_web+'ajax_sprintf.php?arg1='+sing)+'</div>';
                content += '<p style=\"margin-top: 0px;margin-bottom: 30px;padding:0;text-align:center;\">'+s_adresse+'</p>';

                content_id = "sendfriend_alert_mail";

                document.getElementById('product_sendfriend_nok').innerHTML = "";
                document.getElementById('sendfriend_form_to').style.display = "none";
                document.getElementById('sendfriend_form_froms').style.display = "none";
                document.getElementById('sendfriend_form_buttons').style.display = "none";
                document.forms["sendfriendform"].reset();

                $(".form_submit.loading", "#sendfriendform").removeClass("loading");
            } else {
                $('#sendFriendToMails').removeClass('inputErr');
                $('#sendFriendToMessage').removeClass('inputErr');
                $('#sendFriendYourName').removeClass('inputErr');
                $('#sendFriendYourMail').removeClass('inputErr');

                if ($('#sendFriendToMessage').val() == '')
                    $('#sendFriendToMessage').addClass('inputErr');
                if ($('#sendFriendYourName').val() == '')
                    $('#sendFriendYourName').addClass('inputErr');
                if ($('#sendFriendYourMail').val() == '')
                    $('#sendFriendYourMail').addClass('inputErr');


                content = "<img loading='lazy' decoding='async' src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" /><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=error_fields') + "</p>";

                if (response == '1' ) {

                    content = "<img loading='lazy' decoding='async' src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" /><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_no_mail_friends') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '2' ) {

                    content = "<img loading='lazy' decoding='async' src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" /><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_mail_friends_invalid') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '6' ) {

                    content = "<img loading='lazy' decoding='async' src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" /><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_no_my_mail') + "</p>";
                    $('#sendFriendYourMail').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == '7' ) {

                    content = "<img loading='lazy' decoding='async' src=\""+path_relative_root+"img/picto_panneau.png\" style=\"margin-right:10px;float:left;\" /><p style=\"margin: 0px;padding: 0px; line-height: 24px;\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=sendfriend_error_my_mail_invalid') + "</p>";
                    $('#sendFriendToMails').addClass('inputErr');
                    $('td.labelForm').addClass('labelErr');

                } else if (response == 'token_error' ) {

                    content = "<p class=\"txt_err_sendfriend\">" + ajax_file(path_web+'ajax_sprintf.php?arg1=error_token_security') + "</p>";

                } else if (response == '3' || response == '4' || response == '5') {
                    $('#sendFriendToMessage').addClass('inputErr');
                    $('#sendFriendYourName').addClass('inputErr');
                } else {
                    var s_adresse = response.substr(3);
                    var sing = (response.split(',').length > 2) ? 'sendfriend_no_ok_plur' : 'sendfriend_no_ok_sing';

                    content = '<div class="msg_poperror">' + Translator.translate(sing) + '</div>';
                    content_id = "sendfriend_alert_mail";
                    content +=
                        '<div class="form_submit">' +
                            '<a class="button primary" href="#" onclick="closesendfriendmodalfromconfirm()">' +
                                '<span>' + Translator.translate("ok") + '</span>' +
                            '</a>' +
                        '<div>';

                    document.getElementById('product_sendfriend_nok').innerHTML = "";
                    document.getElementById('sendfriend_form_to').style.display = "none";
                    document.getElementById('sendfriend_form_froms').style.display = "none";
                    document.getElementById('sendfriend_form_buttons').style.display = "none";

                    document.getElementById('sendFriendToMails').value = "";
                    document.getElementById('sendFriendToMessage').value = "";
                    document.getElementById('sendFriendYourName').value = "";
                    document.getElementById('sendFriendYourMail').value = "";

                    $(".form_submit.loading", "#sendfriendform").removeClass("loading");
                }
            }

            document.getElementById(content_id).innerHTML = content;
            document.getElementById(content_id).style.display = 'block';
            $('#sendfriend_form_buttons').removeClass('loading');

        });
    }

    return false;
}

function prodGetProductDisplay( id, path_web, type ) {

    if ( typeof(type) == 'undefined' ) {

        var response = ajax_file( path_web + 'ajax_get_infos_send_friend.php?product_id=' +id );
        document.getElementById('sendfriend_prodinfos').innerHTML = response;

    }
    else {

        if ( type == 'look' ) {

            $('#titre_popup').html( ajax_file( path_web + 'ajax_sprintf.php?arg1=sendfriend_title_look ' ) );
            $('#friend_form').show();
            $('#btn_popup_panier').hide();

            $('#bloc_btn_look').show();
            $('#bloc_btn_loader_look').hide();

        }else if (type == 'look_basket') {

            $('#titre_popup').html('Vous venez d\'ajouter le look suivant');
            $('#friend_form').hide();
            $('#btn_popup_panier').show();

            $('#bloc_btn_look').show();
            $('#bloc_btn_loader_look').hide();

        }
        else {

            $('#titre_popup').html('Vous venez d\'ajouter le produit suivant');
            $('#friend_form').hide();
            $('#btn_popup_panier').show();

        }

    }

    if ( navigator.userAgent.indexOf('MSIE') != -1 && navigator.userAgent.indexOf('6.') != -1 ) {

        var svn=document.getElementsByTagName("SELECT");
        for (a=0;a<svn.length;a++) {
            svn[a].style.visibility="hidden";
        }

    }

}

function show_lightbox(lightbox_contact) {

    $('#shade').fadeTo("slow", 0.8).queue(function () {

        $('#' + lightbox_contact).slideDown("slow", function () {

            $('#visu_popup_ajout_panier', this).recalImg();
        });

        $(this).dequeue();
    }).click(function () {

        close_lightbox(lightbox_contact);
    });
}

function close_lightbox(lightbox_contact) {

    $('#' + lightbox_contact).slideUp("slow").queue(function () {

        $('#shade').fadeTo("slow", 0, function () {

            $(this).css('display', 'none');
        });

        $(this).dequeue();
    });
}

function closepopupfacebook() {

    var elname = 'popup_comment_fb';
    var shade = document.getElementById('shade');
    var modbox = document.getElementById(elname);
    modbox.style.display="none";
    shade.style.display="none";

    delEvent(shade,'click',closepopupfacebook);

    closemodal();

}

function fbs_click( site, params ) {

    if ( params == '' ) {
        params = location.href;
    }

    switch ( site ) {
        case 'fb':
            window.open('http://www.facebook.com/share.php?u='+encodeURIComponent(params)+'&t=');
        break;
        case 'tw':
            window.open('https://twitter.com/share?url='+params);
        break;
        case 'pin':
            window.open('http://pinterest.com/pin/create/button/?'+params);

            var url = params.split('&');
            url = url[0].split('=');
            url = decodeURIComponent( url[1] );
        break;
    }
    return false;
}

function stopVideoSpa() {
    var video = $(".wrapper_video");
    var btn_video_produit = $('.btn_video_produit');
    var video_content = $(".video_content", video);
    var videoFlv = $("#video_spa_swf");
    $('#shade').fadeOut('slow');

    video.css({display : 'none', opacity : ''});
}

function lightboxAlertStock( id, type_alert ) {
    var produit_id = $( '#produit_id' ).val();

    if ( !$("#lightbox_stock_alert").is(":visible") )
        var $form = $( '#product_selects' );
    else
        var $form = $( '#form_colisage' );


    var $input = $( '#' + id, $form ); // ID Champs Clique
    var $from = id.split( '_' )[0];
    var $hidden = $( '#' + type + 'Prod', $form );

    var $select = $( '#ligne_' + type );
    var $list_inputs = $( '.select_input', $select );
    var $list_labels = $( '.select_label', $select );

    var data = $form.serialize();
    data += '&produit_id='+produit_id;
    data += '&from=nothing';
    data += '&type_alert=' + type_alert;

    $.ajax({
        type: 'post',
        url: path_relative_root + create_link('ajax_lightbox_alert'),
        data: data,
        success: function( response ) {
            try{
                response = $.parseJSON( response );
            }
            catch( e ) {
                console.error( 'parseJSON' );
                return;
            }

            if ( response.success == 'ok' ) {
                var datas = response.datas;
                var $html = $( datas.html );
                $('#lightbox_stock_alert').html($html);
            }
            else{
                $( '#btn_error' ).fadeIn();
                console.error( response.error.msg );
            }
        },
        complete: function() {
            $('#shade').hide();
            $( '#bloc_btn_loader' ).fadeOut( 300 );
            if ( !$("#lightbox_stock_alert").is(":visible") )
                openMultiShad('lightbox_stock_alert');
            $('.selectStyled').each(function() {
                $(this).selectStyled();
            });
        }
    });
}

var button_add_to_wishlist_initial_click_event;
var button_add_to_wishlist_initial_label;
function restoreWishlistButtonState() {
    $("#addToWishlistButton").html(button_add_to_wishlist_initial_label);
    $("#addToWishlistButton").removeClass("existToWishlistButton").addClass("addToWishlistButton");
    $("#addToWishlistButton").attr("onclick",button_add_to_wishlist_initial_click_event).attr("href", "#");
}

function wishlistRedirectLogin() {
    $.get(path_relative_root + "ajax_add_to_wishlist.php?login_required=1", function() {
        document.location.href=path_relative_root + create_link('connexion_login') + "?from=front";
    });
}

function addToWishlistUpdateHeader(nr) {
    $(".btn_top_wishlist .gris").html('(x' + nr + ')');

    if (nr == 0) {
        $("#basket1").show();
        $("#basket2").hide();
        $(".btn_top_wishlist").hide();
        $("#number_wishlist_top").html('(0)');
    } else {
        $("#basket2").show();
        $("#basket1").hide();
        $(".btn_top_wishlist").show();
        $("#number_wishlist_top").html('(x' + nr + ')');
    }
}

var look_add = false;

function addLook(loader) {

    $(loader).fadeIn(200);

    look_add = true;

    calculTotal('slide_look_detail', true);
}

function calculTotal(id, process_look) {

    var $form = $(document.getElementById(id));
    var data = $form.serialize();

    $.ajax({
        type : 'post',
        url : path_relative_root + 'ajax_calcul_total.php',
        data : data,
        success : function (response) {

            try {

                response = JSON.parse(response);
            } catch (e) {

                console.error('parseJSON');

                return;
            }

            if (response.success == 'ok') {

                var datas = response.datas;
                var total = datas.total;

                $('#look_total', '#look_info').val(total);
                $('.price_total', '#look_info').html(datas.total_format);

                if (process_look) {

                    if (total > 0) {

                        if (!addToCartTmpl) {

                            addToCartTmpl = document.getElementById('modbox').innerHTML.trim();

                            Mustache.parse(addToCartTmpl);
                        }

                        buildLookAddedModbox(false);
                        processlook();
                    } else {
                        var $alertbox = $( '#alertbox1' );
                        res = ajax_file(path_relative_root+'ajax_sprintf.php?arg1=js_error_quantity');
                        html_err = '<div class="txt_alert"></div><div class="rosette"></div>';
                        html_err += '<div class="wrapper_btn"><a onclick="closeMultiShad();" href="#" class="btn_alert">OK</a></div>';

                        if ($alertbox.length == 0) {
                            $alertbox = $('<div id="alertbox1">'+ html_err +'</div>');
                            $('body').append($alertbox.hide());
                        }

                        $alertbox.find('.txt_alert').html(res);
                        openMultiShad('alertbox1', 'fixed');
                        $('#bloc_btn_look').show();
                        $('#bloc_btn_loader_look').hide();

                        if ($('.loader', '#bloc_add_basket').length > 0)  {
                            $('.loader', '#bloc_add_basket').hide();
                        }
                    }
                }
            }
        }
    });
}

function loadPrevisu() {

    var cpt = 0,
        $array_product_previsu = [];

    $('.array_produit_total').map(function () {

        var $current_product = $(this).val();
        var $current_product_qte = $('#qteProd_' + $current_product).val();

        if ($current_product_qte > 0) {

            $array_product_previsu[cpt] = [];

            $array_product_previsu[cpt]['id'] = $current_product;
            $array_product_previsu[cpt]['img'] = $('#img_produit_' + $current_product).attr('src');
            $array_product_previsu[cpt]['price'] = $('#price_' + $current_product).html();
            $array_product_previsu[cpt]['qte'] = $current_product_qte;

            cpt++;
        }
    }).get();

    return $array_product_previsu;
}

function processlook() {
    $('.submit_panier').each(function () {
        var $elem = $(this).attr('id');
        var $id = $elem.substring($elem.lastIndexOf("_") + 1);
        var $val_item = $("#qteProd_" + $id).val();

        if ($val_item > 0) {
            $("#look_add_lightbox_" + $id).show();
            $(this).click();
        } else {
            $("#look_add_lightbox_" + $id).hide();
        }
    });

    setTimeout(showsendfriendmodal, 1000, 0, path_relative_root, 'look_basket');
}

// popup PDV
function showpdv() {

    var shade, modbox, contents;

    $.ajax({
        type : 'post',
        url : path_relative_root + 'ajax-distributeurs.php',
        success : function (res) {

            if (res) {

                shade = document.getElementById('shade');
                modbox = document.getElementById('pdvBox');

                contents = $('<div />').html(res);

                // Make sure modbox will show on top of shade
                $(shade).after(modbox);

                // Inject store locator into modbox
                $('.store_locator', modbox).html($('.storeloc_form', contents).add($('.liste_recherche_distributeur', contents)));

                initialize();

                // Show modbox and make sure closing routine won't fire more than once
                $(shade).off('click', closepdv).fadeIn(200, function () {

                    $(modbox).slideDown(600);
                    $(shade).on('click', closepdv);

                    // Init locator
                    if (navigator.geolocation) {
                        var crd = navigator.geolocation.getCurrentPosition(rechercheProximite);
                    }
                });
            }
        }
    });
}

function closepdv() {

    var shade = document.getElementById('shade');
    var modbox = document.getElementById('pdvBox');

    // Hide modbox and shade and destroy shade's click event
    $(modbox).slideUp(600, function () {

        $(shade).off('click', closepdv).stop(true, true).fadeOut(200);
    });
}

function createThumb(data) {

    var template = document.getElementById('thumb_tpe').innerHTML,
        rendered = Mustache.render(template, data),
        new_item = document.createElement('li');

    new_item.className = 'itm_thumb';
    new_item.innerHTML = rendered;

    document.getElementById('itm_thumb_list').appendChild(new_item);
}

function parseThumbList(list) {

    var thumb, qte, i;

    for (thumb in list) {

        if (list.hasOwnProperty(thumb)) {

            thumb = list[thumb];
            qte   = thumb.qte;

            delete thumb.qte;

            for (i = 0; i < qte; i += 1) {

                createThumb(thumb);
            }
        }
    }
}

function createCookie(name,value,days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        var expires = "; expires="+date.toGMTString();
    } else {
        var expires = "";
    }

    document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }

    return null;
}

var reservationDate = true;

function giftAndReservation(exeperienceType) {
    if (exeperienceType == 'reservation') {
        reservationDate = true;
    } else {
        reservationDate = false;
    }
}

function checkreservation(special_reservation) {
    var error = false;
    var date_now = new Date();

    if (special_reservation == '1' && special_reservation != 'undefined') {
        return false;
    }

    // Check Reservation Date
    if ($('#reservation_date').val() == '' && reservationDate) {
        $('#reservation_date').addClass('error');
        error = true;
    } else {
        var reservation_date = $('#reservation_date').val().split('/');

        if ( (reservation_date[0] == '' || reservation_date[1] == '' || reservation_date[2] == '') && reservationDate ) {
            $('#reservation_date').addClass('error');
            error = true;
        } else {
            var date_selected = new Date(reservation_date[2] + '-' + reservation_date[1] + '-' + reservation_date[0]);

            if (date_selected < date_now && reservationDate) {
                $('#reservation_date').val('');
                $('#reservation_date').addClass('error');
                error = true;
            } else {
                $('#reservation_date').removeClass('error');
            }
        }
    }

    // Check Reservation Passagers
    var nb_passenger = $('#reservation_nb_passagers').val();

    for (var i = 1; i <= nb_passenger; i++) {
        $('#reservation_nom_' + i).removeClass('error');
        $('#reservation_prenom_' + i).removeClass('error');
        $('#reservation_email_' + i).removeClass('error');

        if ($('#reservation_nom_' + i).val() == '') {
            $('#reservation_nom_' + i).addClass('error');
            error = true;
        }

        if ($('#reservation_prenom_' + i).val() == '') {
            $('#reservation_prenom_' + i).addClass('error');
            error = true;
        }

        if ($('#reservation_email_' + i).val() == '') {
            $('#reservation_email_' + i).addClass('error');
            error = true;
        } else {
            var mail_rule = new RegExp("^[a-z0-9_-]+([.]?[a-z0-9_-]{1,})*@([a-z0-9_-]{2,}[.])+[a-z]{2,4}$","gi");
            if (mail_rule.exec($('#reservation_email_' + i).val()) == null) {
                $('#reservation_email_' + i).addClass('error');
                error = true;
            }
        }
    }
    return error;
}

function showsendfriendmodal( product_id, path_web, type ) {
    var elname = type === "look_basket" ? "modbox" : "sendfriendbox";
    var actualposition = document.documentElement.scrollTop;

    if ( type !== 'look_basket' ) {
        var psnok = document.getElementById( 'product_sendfriend_nok' );
        var psfok = document.getElementById( 'product_sendfriend_ok' );
        if ( psnok ) {
            psnok.innerHTML = '';
            psnok.style.display = 'none';
        }
        if ( psfok ) {
            psfok.innerHTML = '';
            psfok.style.display = 'none';
        }

        prodGetProductDisplay( product_id, path_web, type );

        openMultiShad( "sendfriendbox" );
    } else {
        show_lightbox( elname );
        reloadLookparts();
        $( ".loader", "#bloc_add_basket" ).hide();
    }
}